import { render, staticRenderFns } from "./TreeChartDrawer.vue?vue&type=template&id=70d256dd"
import script from "./TreeChartDrawer.vue?vue&type=script&lang=ts"
export * from "./TreeChartDrawer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports